import "./OrderSummary.css";
import {
    ShoppingBag, Truck, BadgePercent, TicketPercent, Wallet, ShieldCheck,
} from "lucide-react";

import SummaryRow from "./SummaryRow";
export default function OrderSummary({
    summary,

}) { 

    const money = (value) =>  Number(value).toLocaleString("fa-IR");

    return (

        <aside className="order-summary">

            <div className="summary-header">

                <h3>

                    خلاصه سفارش

                </h3>

            </div>

            <SummaryRow

                label="تعداد محصول"

                value={`${summary.itemCount} محصول`}

            />

            <SummaryRow

                label="جمع محصول"

                value={`${money(summary.subtotal)} تومان`}

            />

            <SummaryRow

                label="تخفیف محصول"

                value={`${money(summary.productDiscount)} تومان`}

                type="discount"

            />

            <SummaryRow

                label="هزینه ارسال"
                value={
                    summary.shippingPrice === 0

                        ? "رایگان"

                        :

                        `${money(summary.shippingPrice)} تومان`
                }

            />

            <SummaryRow

                label="کد تخفیف"

                value={`${money(summary.couponDiscount)} تومان`}

                type="discount"

            />

            {
                summary.walletUsed ? (
                    <>
                    <SummaryRow
                        label=" کیف پول"
                        value={`${money(summary.walletUsed)} تومان`}
                        type="wallet"
                    />
                    </>
                ) : <></>
            }




            <div className="summary-divider" />

            <SummaryRow

                label="مبلغ قابل پرداخت"

                value={`${money(summary.payable)} تومان`}

                type="total"

            />

        </aside>

    );

}